import * as React from "react";
import { Post } from "interfaces/wordpress";

import ImageContainer from "lib/image-container";
import ArticleRelatedPosts from "components/the-buzz-theme/article/article-related-posts";

const lexemes = {
  articleTagsTitle: "Article Tags",
  articleTagsSubTitle: " Tag",
  articleTagsTitleWithSpace: "Article Tags: ",
  articleCategoryTitle: "Article Category",
  articleCategoryTitleWithSpace: "Article Category: ",
  articleCategorySubTitle: " Category",
  copyCta: "Copy URL for article",
};

export type Props = {
  post: Post;
  relatedPosts?: Post[] | null;
  categoryColor?: string;
  categoryName?: string;
  hasTags?: boolean;
  hasCategories?: boolean;
  content?: string;
};

export default function ArticleContent({
  categoryColor,
  categoryName,
  post,
  hasTags,
  hasCategories,
  content,
  relatedPosts,
}: Props) {
  const contentElement = (
    <div
      className="formatted-text"
      dangerouslySetInnerHTML={{
        __html: `${content}`,
      }}
    />
  );
  return (
    <div className="container-xxl">
      <div className="row">
        <div className="col-sm-12">
          <div id="primary" className="content-area">
            <div
              id="content"
              className={`site-content clearfix ${categoryColor}`}
            >
              {/*  */}
              <section className="entry-header">
                <div className="row align-items-start">
                  <div className="col-12 col-md-7 entry-header-left">
                    <h1
                      className="entry-title"
                      dangerouslySetInnerHTML={{ __html: `${post.title}` }}
                    />
                  </div>
                  <div className="col-12 col-md-5 entry-header-right">
                    <div className="row">
                      <div className="col-11 col-sm-11 entry-header-list">
                        <div className="entry-meta entry-meta-top">
                          {hasTags ? (
                            <>
                              <span className="screen-reader-text">
                                {lexemes.articleTagsTitleWithSpace}
                              </span>
                              <ul
                                className="tag-list"
                                aria-label={lexemes.articleTagsTitle}
                              >
                                {post.tags?.edges.map((edge, key) => (
                                  <li key={key}>
                                    <a
                                      // @ts-ignore
                                      href={`/the-buzz/tag/${edge?.node?.slug || ""}`}
                                      rel="tag"
                                    >
                                      {/* @ts-ignore */}
                                      {edge.node.name}
                                      <span className="screen-reader-text">
                                        {lexemes.articleTagsSubTitle}
                                      </span>
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </>
                          ) : null}
                          {!hasTags && hasCategories ? (
                            <>
                              <span className="screen-reader-text">
                                {lexemes.articleCategoryTitleWithSpace}
                              </span>
                              <ul
                                className="tag-list"
                                aria-label={lexemes.articleCategoryTitle}
                              >
                                {post.categories?.edges.map((edge, key) => (
                                  <li key={key}>
                                    <a
                                      href={`/the-buzz/${edge.node.slug}`}
                                      rel="tag"
                                    >
                                      {/* @ts-ignore */}
                                      {edge.node.name}
                                      <span className="screen-reader-text">
                                        {lexemes.articleCategorySubTitle}
                                      </span>
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-1 col-sm-1 tooltip-inner">
                        <button
                          type="button"
                          role="tooltip"
                          className="btn-share"
                          data-bs-toggle="tooltip"
                          data-bs-title="Copy article link"
                        >
                          <svg
                            xmlns="https://www.w3.org/2000/svg"
                            focusable="false"
                            role="graphics-symbol"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6 6H4C2.34315 6 1 7.34315 1 9V20C1 21.6569 2.34315 23 4 23H20C21.6569 23 23 21.6569 23 20V9C23 7.34315 21.6569 6 20 6L18 6"
                              stroke="#1d252c"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M12 15V1M12 1L9 4M12 1L15 4"
                              stroke="#1d252c"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span className="screen-reader-text">
                            {lexemes.copyCta}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <article className="type-post status-publish format-standard has-post-thumbnail hentry">
                <div className="single-topimg">
                  {post?.featuredImage?.node?.mediaItemUrl ? (
                    <ImageContainer
                      className="attachment-large size-large wp-post-image"
                      alt={post?.featuredImage?.node?.altText || ""}
                      src={post?.featuredImage?.node?.mediaItemUrl}
                      height={
                        post?.featuredImage?.node?.mediaDetails?.height || 0
                      }
                      width={
                        post?.featuredImage?.node?.mediaDetails?.width || 0
                      }
                    />
                  ) : null}
                </div>

                <div className="entry-content clearfix">
                  <div className="row g-0">
                    {relatedPosts ? (
                      <>
                        <div className="col-12 col-sm-12 col-md-7 col-lg-8 post-content-left">
                          {contentElement}
                        </div>
                        <div className="col-12 col-sm-12 col-md-5 col-lg-4 post-content-right related-posts-desktop">
                          <ArticleRelatedPosts
                            relatedPosts={relatedPosts}
                            categoryName={categoryName}
                          />
                          {/* // <?php yrpp_related(); ?> */}
                        </div>
                      </>
                    ) : (
                      <div className="col-12 post-content-left">
                        {contentElement}
                      </div>
                    )}
                  </div>
                </div>
              </article>
              {/* @TODO - add render conditions */}
              <div className="related-posts-mobile">
                <ArticleRelatedPosts
                  relatedPosts={relatedPosts}
                  categoryName={categoryName}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
